export default __webpack_public_path__ + "static/media/MyPathMainNav.99152d4e.jpg";